<template>
   
	<div v-if="imageSrc" :style="computedStyle" >
        <div  v-if="isFileFormat === 'svg'" >
      <object ref="svgObject" :data="source" type="image/svg+xml" :style="computedStyle"></object>
      <div class="click-overlay" :style="computedStyle"></div>
   </div>
   <div v-else>
	<video ref="video" v-if="supportsWebM" :style="computedStyle" autoplay loop muted playsinline >

      <source :src="source"  type="video/webm" />
     
    </video>
    <img v-else alt="play" class="front" src="/images/play_button.svg">
    <!-- <img v-else alt="play" class="front" src="/images/play_button.svg"> -->
   </div>
   
    </div>
    <img v-else-if="isVideo" alt="play" class="front" src="/images/play_button.svg">

    

</template>

<script>
import { mapActions, mapGetters} from "vuex";
import featureMixin from "@/mixins/featureMixin";

export default {
	name: "PlayButton",
    mixins: [featureMixin],
	data() {
		return {
            supportsWebM: false,
			featurePath: 'blockVideos.fullBlock',
            videoLoaded: true
		}
	},
    props: {
		product: {
			type: Object,
			default: () => {
				return {}
			},
            region: {
                type: Object,
                default: () => {
				return {}
			},
            },
		}
	},
    mounted() {
    this.checkWebMSupport();
    const v = this.$refs.video;
    v?.play()
    if(window.navigator.userAgent.indexOf("Edg")> -1){
      v?.setAttribute('disablePictureInPicture', true);
      v?.setAttribute('controlsList','nodownload')
    }
  
 
  },
	computed: {
		...mapGetters('config', ['branding']),
        computedStyle() {
            return {
				width: `100%`,
				height: `100%`,
				position: this.isCTCGrandOpening ? 'relative' : 'absolute'
			}
        },
        sku() {
    //   if((this.product.sku || '').toLowerCase().includes('inblock'))
    //     return this.product.sku.split('|')[0].toLowerCase()
    //   else
        return (this.product.sku || '').toLowerCase().trim();
    },
        regions() {
			return this.product.clickRegions;
		},
        source() {
            return `${this.product.url}${this.config?.accessKey || ''}`;
        },
        actionType() {
			return (this.product.actionType || '')?.toLowerCase().trim()
		},
        isVideo() {
            const actionType = (this.actionType || this.sku).toLowerCase();
			return actionType.includes('inblock') ||  actionType.includes('animate') || actionType.includes('play');
		},
        imageSrc() {
         return  (this.actionType && (this.actionType === 'play') && this.product.url && this.isFileFormat)
		},
        isFileFormat() {
            const url = this.product?.contentSource || this.product?.url;
            if(url.endsWith('.webm')) {
                return 'webm'
            } else if (url.endsWith('.svg')) {
                return 'svg'
            }
            return null;
        }
	},
	methods: {
		...mapActions('toast', ['toggleHelp']),
        play() {
      this.$refs.video.play();
    },
  checkWebMSupport() {
    const video = document.createElement('video');
    this.supportsWebM = video.canPlayType('video/webm; codecs="vp8, vorbis"') !== '';
  }

		
	}
}
</script>

<style lang="scss" scoped>
   object {
      display: block;
      .click-overlay {
      position: absolute;
      background: transparent;
     }
   }
</style>
